// removed by extract-text-webpack-plugin
module.exports = {"container":"_20AKj","input":"_1JIaK","borders":"VXuDD"};


//////////////////
// WEBPACK FOOTER
// ./app/components/read-only-input/read-only-input.scss
// module id = 881
// module chunks = 3 4 5 6 7